// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import AccountSideMenu from 'Containers/AccountSideMenu/AccountSideMenu';
import Orders from 'Containers/Orders/Orders';

const StyledOrdersPage = styled.div`
  display: grid;
  grid-template-columns: 260px auto;
  grid-column-gap: 30px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: auto;

    aside {
      display: none;
    }
  }
`;

const OrdersPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};

  let ordersPageClassNames = bodyAttributes?.class || '';
  if (!ordersPageClassNames.includes('OrdersPage')) {
    ordersPageClassNames += 'OrdersPage';
  }

  return (
    <>
      <Helmet>
        <body className={ ordersPageClassNames } />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('common.pages.orders') }</title>
      </Helmet>
      <StyledOrdersPage theme={ theme } className="grid-container">
        <AccountSideMenu />
        <Orders />
      </StyledOrdersPage>
    </>
  );
});

OrdersPage.displayName = 'OrdersPage';

export default OrdersPage;
